/*
 * @Description: SDK组件相关通信接口
 */
import jsBridge from '../common/jsBridge'
import App from '../class/App'

function getInvokeDatas(action, params = {}){
  const { data } = params
  /*const view = {
      "type":1,//组件的类型
      "id":"2343214",//组件的实例id
      "unitId":"85904385"

  }*/
  return {
      fnName: 'VideoBridge/operateComponent',
      params:{
          action,
          unitid: App && App.mainOpts && App.mainOpts.unit_id,
          data: {
              unitid: App && App.mainOpts && App.mainOpts.unit_id,
              ...data
          }
      }
  }
}


/**
 * 创建一个webview组件
 * @param params
 * @returns {*|Promise<any>}
 */
export function createWebview (params = {}) {
    const action = 'VideoBridge/createWebview'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 创建视频播放组件
 * @param params
 * @returns {*|Promise<any>}
 */
export function createPlayerView (params = {}) {
    const action = 'VideoBridge/createPlayerView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 创建StoreKit视图
 * @param params
 * @returns {*|Promise<any>}
 */
export function createStoreKitView (params = {}) {
    const action = 'VideoBridge/createStoreKitView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 创建旧的视频播放模板组件
 * @param params
 * @returns {*|Promise<any>}
 */
export function createSubPlayTemplateView (params = {}) {
    const action = 'VideoBridge/createSubPlayTemplateView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 创建旧的endcard组件
 * @param params
 * @returns {*|Promise<any>}
 */
export function createEndCard (params = {}) {
    const action = 'VideoBridge/createEndCard'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 创建旧的endcard组件
 * @param params
 * @returns {*|Promise<any>}
 */
export function createOM (params = {}) {
    const action = 'VideoBridge/创建OM组件'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 销毁组件
 * @param params
 * @returns {*|Promise<any>}
 */
export function destroyComponent (params = {}) {
    const action = 'VideoBridge/destroyComponent'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：3，获取视图的信息
 * @param params
 * @returns {*|Promise<any>}
 */
export function getComponentOptions (params = {}) {
    const action = 'VideoBridge/getComponentOptions'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：4，设置视图的信息
 * @param params
 * @returns {*|Promise<any>}
 */
export function setComponentOptions (params = {}) {
    const action = 'VideoBridge/setComponentOptions'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：5，修改视图frame
 * @param params
 * @returns {*|Promise<any>}
 */
export function setViewRect (params = {}) {
    const action = 'VideoBridge/setViewRect'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：6，从父视图移除视图（默认未释放该对象）
 * @param params
 * @returns {*|Promise<any>}
 */
export function removeFromSuperView (params = {}) {
    const action = 'VideoBridge/removeFromSuperView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 在当前视图上添加其他视图
 * @param params
 * @returns {*|Promise<any>}
 */
export function appendSubView (params = {}) {
    const action = 'VideoBridge/appendSubView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 将当前视图添加到指定视图上
 * @param params
 * @returns {*|Promise<any>}
 */
export function appendViewTo (params = {}) {
    const action = 'VideoBridge/appendViewTo'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 移动当前视图到父视图的顶部
 * @param params
 * @returns {*|Promise<any>}
 */
export function bringViewToFront (params = {}) {
    const action = 'VideoBridge/bringViewToFront'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 隐藏视图
 * @param params
 * @returns {*|Promise<any>}
 */
export function hideView (params = {}) {
    const action = 'VideoBridge/hideView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 显示视图
 * @param params
 * @returns {*|Promise<any>}
 */
export function showView (params = {}) {
    const action = 'VideoBridge/showView'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 设置视图的背景颜色
 * @param params
 * @returns {*|Promise<any>}
 */
export function setViewBgColor (params = {}) {
    const action = 'VideoBridge/setViewBgColor'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 设置视图的透明度
 * @param params
 * @returns {*|Promise<any>}
 */
export function setViewAlpha (params = {}) {
    const action = 'VideoBridge/setViewAlpha'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * 设置视图的缩放
 * @param params
 * @returns {*|Promise<any>}
 */
export function setViewScale (params = {}) {
    const action = 'VideoBridge/setViewScale'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * webview加载url
 * @param params
 * @returns {*|Promise<any>}
 */
export function webviewLoad (params = {}) {
    const action = 'VideoBridge/webviewLoad'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * reload
 * @param params
 * @returns {*|Promise<any>}
 */
export function webviewReload (params = {}) {
    const action = 'VideoBridge/webviewReload'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * goback
 * @param params
 * @returns {*|Promise<any>}
 */
export function webviewGoBack (params = {}) {
    const action = 'VideoBridge/webviewGoBack'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * goforward
 * @param params
 * @returns {*|Promise<any>}
 */
export function webviewGoForward (params = {}) {
    const action = 'VideoBridge/webviewGoForward'
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}







/**
 * action：200，原生视频-播放
 * @param params
 * @returns {*|Promise<any>}
 */
export function nativeVideoPlay (params = {}) {
    const action = 200;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：201，原生视频-暂停
 * @param params
 * @returns {*|Promise<any>}
 */
export function nativeVideoPause (params = {}) {
    const action = 201;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：202，原生视频-停止
 * @param params
 * @returns {*|Promise<any>}
 */
export function nativeVideoStop (params = {}) {
    const action = 202;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：203，原生视频-更新帧
 * @param params
 * @returns {*|Promise<any>}
 */
export function nativeVideoUpdateFrame (params = {}) {
    const action = 203;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：204，原生视频-静音
 * @param params
 * @returns {*|Promise<any>}
 */
export function nativeVideoMute (params = {}) {
    const action = 204;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：205，原生视频-替换视频源
 * @param params
 * @returns {*|Promise<any>}
 */
export function nativeVideoReplaceSource (params = {}) {
    const action = 205;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}





/**
 * action：301，预加载storeKit
 * @param params
 * @returns {*|Promise<any>}
 */
export function preloadStoreKit (params = {}) {
    const action = 301;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * action：302，添加stk到父视图
 * @param params
 * @returns {*|Promise<any>}
 */
export function addStoreKitTo (params = {}) {
    const action = 302;
    const invokeParams = getInvokeDatas(action, params)
    return jsBridge.callNative(invokeParams)
}

